// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"d54e0528","977":"3d32bc3d"}[chunkId] + ".chunk.js";
};